import React from "react";
import { Link } from "react-router-dom";
// This tells the component to go up one level (from components / to src/) and then into the pages folder where OuraNav.css is located
import '../pages/OuraNav.css';

// Allow optional calendar toolbar controls to be passed in
const OuraNav = ({ links = [], calendarControls = null, backButton = null }) => {
    return (
        <nav className="apple-global-nav">
            <div className="left-nav">
                <img src="/images/logoPlaceholder1.png" alt="Logo" className="apple-logo" />
                {backButton && (
                    <button
                        onClick={backButton.onClick}
                        style={{ marginLeft: "24px", background: "none", border: "none", color: "#0071e3", fontSize: "13px", cursor: "pointer" }}
                    >
                        ← {backButton.label}
                    </button>
                )}
            </div>
            <div className="center-nav">
                {links.map(({ label, href }) => (
                    <a key={label} href={href || "#"}>
                        {label}
                    </a>
                ))}
            </div>
            <div className="right-nav">
                <div className="account-dropdown-container">
                    <span className="account-link">Account</span>
                    <div className="account-dropdown">
                        <Link to="/account/profile">Profile</Link>
                        <Link to="/account/security">Security</Link>
                        <Link to="/logout">Log Out</Link>
                    </div>
                </div>
            </div>
            {/*// Calendar toolbar injected from parent page (e.g., Scheduler)*/}
            {calendarControls && (
                <div className="oura-calendar-controls">
                    <button onClick={() => calendarControls.onNavigate("TODAY")}>Today</button>
                    <button onClick={() => calendarControls.onNavigate("PREV")}>&lt;</button>
                    <button onClick={() => calendarControls.onNavigate("NEXT")}>&gt;</button>
                    <span className="calendar-label">{calendarControls.label}</span>
                    <div className="view-switcher scheduler-only">
                        {calendarControls.views.map((v) => (
                            <button
                                key={v}
                                onClick={() => calendarControls.onView(v)}
                                className={calendarControls.view === v ? "active" : ""}
                            >
                                {v.charAt(0).toUpperCase() + v.slice(1)}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </nav>
    );
};

export default OuraNav;